import { Directive } from '@angular/core';

@Directive({
  selector: '[wcgInlineEditMode]',
  standalone: true,
})
export class EditModeDirective {}
